import { GradeSheetsViewModel } from '@/api';
import { GradeSheetResponse } from '@/api/api-client';

export const mapGradeSheets = (data: GradeSheetResponse[]): GradeSheetsViewModel[] => {
  return data.map(item => ({
    id: item._id,
    filePath: item.file_path,
    grader: item.grader,
    assessment: item.assessment,
    scores: item.scores,
    scoresChecked: item.scores_checked,
  }))
}